import emailTrackerApi from '@/api/EmailTracker/api'

export default {
  methods: {
    async createEmailTracker ({userId, messageId, threadId}) {
      try {
        const res = await emailTrackerApi.createEmailTracker({userId, messageId, threadId})
        return res.data
      } catch (err) {
        console.error(err)
        return {}
      }
    },
    async updateEmailTracker (body) {
      try {
        const res = await emailTrackerApi.updateEmailTracker(body)
        return res.data
      } catch (err) {
        console.error(err)
        return {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/createEmailTracker.js